import {Link} from 'react-router-dom';
import React from 'react';

export default {
  mnj: {
    slogan: 'Всё начинается с того, что Вы важны…®',
    description: 'Платформа для контактного подбора персонала <br/> и поиска работы!',
  },
  roles: {
    candidate: 'Соискатель',
    employer: 'Работодатель',
    recruitmentAgency: 'Кадровое агенство',
    admin: 'Администратор',
    guest: 'Гость',
    user: 'Пользователь',
    participant: 'Участник',
  },
  landingPage: {
    partnersSection: {
      intro: 'нам доверяют',
      title: 'С нами уже работают',
    },
    videoMaterials: {
      intro: 'иногда примеры вдохновляют',
      title: 'Видеоматериалы',
      video1: 'Пример записи самостоятельного видеорезюме',
      video2: 'Пример записи видеорезюме с ассистентом платформы',
      video3: 'Пример записи видеособеседования',
      video4: 'Пример записи самостоятельной видеовакансии',
      video5: 'Пример записи видеовакансии с ассистентом платформы',
      video6: 'Пример записи видеовизитки',
    },
    tariffs: {
      title: 'Услуги и тарифы',
      slogan: 'Приятно сделать правильный выбор',
      showAsTable: 'Показать в табличном виде',
      showAsTiles: 'Показать в виде плиток',
    },
    reviews: {
      title: 'Отзывы наших клиентов',
      slogan: 'Что о нас говорят',
      text: 'Мы стремимся быть полезными для своих пользователей и тщательно следим за обратной связью',
    },
    partners: {
      title: 'С нами уже работают',
      slogan: 'Нам доверяют',
    },
    joinUs: {
      title: 'Оставайтесь в курсе всех нововведений и обновлений',
      text: 'Мы постоянно развиваемся и следим за тем, чтобы быть максимально полезными для своих пользователей. Если хотите узнавать первыми о нововведениях на платформе, смело оставляйте электронную почту.',
    },
  },
  system: {
    videoResume: 'Видеорезюме',
    videoVacancy: 'Видеовакансия',
    videoReview: 'Видеособеседование',
    videoBusinessCard: 'Видеовизитка',
    videoConversation: 'Видеобеседа',
  },
  aboutPlatformModalForm: {
    notifyTitle: 'Вам стало интересно? ',
    notifyText: 'Хотите узнать о платформе My new job® больше? Оставьте свои контактные данные, чтобы мы перезвонили или написали Вам в ближайшее время.',
    notifyBtn: 'Оставить контактные данные',
    modalTitle: 'Узнать о возможностях платформы My new job®',
    modalText: 'Хотите узнать о платформе для контактного подбора персонала больше? Оставьте свои контактные данные, чтобы мы перезвонили или написали Вам в ближайшее время.',
  },
  plans: {
    accessPlans: 'Тарифы на доступы',
    servicesPlans: 'Тарифы на услуги',
    details: 'Подробнее',
    addToCart: 'Добавить в корзину',
    popular: 'Популярно',
    rubMonth: 'рублей/месяц',
    rub: 'рублей',
    from: 'от',
    discountText: 'Скидка более',
    totalSaving: 'Итого экономия',
    rubPerMonth: 'рублей в месяц',
    currentPlan: 'Ваш текущий тарифный план ',
    forCandidates: 'Для соискателей',
    forEmployers: 'Для работодателей',
    forAgency: 'Для кадровых агентств',
    planType1: 'Неограниченый доступ к проведению онлайн-видеосессий',
    planType2: 'Неограниченый доступ к записи онлайн-видеосессий',
    planType3: 'Неограниченый доступ к записи видеоопросов',
    planType4: 'Неограниченый доступ к базе данных резюме',
    planType5: 'Доступ к возможности публикации вакансий',
    planType6: 'Объём хранилища для записи онлайн-видеосессий',
    planSubscribe: 'Подпишитесь, чтобы не пропустить обновления!',
    updatesInform: 'Сообщить о появлении ',
    subscribeTitle: 'Подпишитесь на нашу рассылку',
    subscribeText: 'Подпишитесь на нашу рассылку и будьте в курсе всех обновлений. Получайте самые выгодные предложения первыми!',
    subscribe: 'Подписаться',
    freeCandidate: {
      title: 'Бесплатно',
      descr: 'Бесплатный доступ к онлайн-видеосессиям без записи',
      includeText: 'Неограниченный доступ к <b>проведению</b> онлайн-видеосессий',
      includeText2: 'Неограниченный доступ к <b>записи</b> онлайн-видеосессий',
      includeText3: 'Возможность <b>записи</b> самостоятельных видеорезюме',
    },
    baseCandidate: {
      title: 'Базовый',
      descr: 'Доступ к онлайн-видеосессиям с возможностью записи',
      includeText: 'Неограниченный доступ к <b>проведению</b> онлайн-видеосессий',
      includeText2: 'Неограниченный доступ к <b>записи</b> онлайн-видеосессий',
      includeText3: 'Возможность <b>записи</b> самостоятельных видеорезюме',
    },
    free: {
      title: 'Бесплатно',
      descr: 'Бесплатный доступ к онлайн-видеосессиям без записи',
      includeText: 'Неограниченный доступ к <b>проведению</b> онлайн-видеосессий',
      includeText2: 'Неограниченный доступ к <b>записи</b> онлайн-видеосессий',
      includeText3: 'Возможность <b>записи</b> самостоятельных видеовакансий',
    },
    base: {
      title: 'Базовый',
      descr: 'Доступ к онлайн-видеосессиям с возможностью записи',
      includeText: 'Неограниченный доступ к <b>проведению</b> онлайн-видеосессий',
      includeText2: 'Неограниченный доступ к <b>записи</b> онлайн-видеосессий',
      includeText3: 'Возможность <b>записи</b> самостоятельных видеовакансий',
    },
    all: {
      title: 'Всё включено',
      descr: 'Доступ к видеосессиям и видеоопросам с возможностью записи, а также к базе данных резюме и публикациям вакансий',
      includeText: 'Неограниченный доступ к <b>проведению</b> и <b>записи</b> онлайн-видеосессий',
      includeText2: 'Неограниченный доступ к проведению <b>видеоопросов</b> кандидатов',
      includeText3: 'Неограниченный доступ к базе данных <b>резюме</b> и публикациям <b>вакансий</b>',
    },
    video_resume: {
      title: 'Запись видеорезюме',
      descr: 'Запись видеорезюме с ассистентом сайта',
      includeText: 'Услуга по <b> записи видеорезюме </b> с ассистентом сайта',
      includeText2: 'Услуга за указанную стоимость предоставляется разово',
      includeText3: 'Дата и время проведения <b>видеорезюме </b> назначается Вами',
    },
    videos_question: {
      title: 'Запись видеоопросов',
      descr: 'Доступ к видеосессиям и видеоопросам с возможностью записи',
      includeText: 'Неограниченный доступ к <b>проведению</b> и <b>записи</b> онлайн-видеосессий',
      includeText2: 'Возможность <b>записи</b> самостоятельных видеовакансий',
      includeText3: 'Неограниченный доступ к проведению <b>видеоопросов</b> кандидатов',
      includeText4: 'странице',
    },
    videos_vacancy: {
      title: 'Запись видеовакансии',
      descr: 'Запись видеовакансии с ассистентом сайта',
      includeText: 'Услуга по <b>записи видеовакансии</b> с ассистентом сайта',
      includeText2: 'Услуга за указанную стоимость предоставляется разово',
      includeText3: 'Дата и время проведения <b>видеовакансии</b> назначается Вами',
    },
    staff_recruitment: {
      title: 'Подбор персонала',
      descr: 'Стоимость указана за подбор одного сотрудника',
      includeText: 'Сотрудники на конкретную вакансию предоставляется с <b>видеорезюме</b>',
      includeText2: 'Подбор сотрудников на вакансию осуществляется до полного <b>её закрытия</b>',
      includeText3: 'Стоимость подбора сотрудника указана в среднем, подробные условия представлены на ',
      includeText4: 'странице',
    },
    candidates_flow: {
      title: 'Поток кандидатов',
      descr: 'Предоставление до 10 кандидатов в месяц на одну вакансию',
      includeText: 'Сотрудники на конкретную вакансию предоставляются с <b>видеорезюме</b>',
      includeText2: 'Максимальное количество кандидатов в месяц на одну вакансию - <b>10 человек</b>',
      includeText3: 'Если из всего потока кандидатов никто не подошёл, Вы можете <b>продлить</b> услугу',
    },
  },
  periods: {
    oneMonth: 'месяц',
    threeMonth: 'три месяца',
    sixMonth: 'полгода',
    twelveMonth: 'год',
  },
  menuLinks: {
    howItWork: 'Как это работает?',
    aboutCompany: 'О компании',
    news: 'Новости',
    youCandidate: 'Для соискателей',
    youEmployer: 'Для работодателей',
    youAgency: 'Для кадровых агентств',
    policy: 'Политика обработки персональных данных',
    documents: 'Правовые документы',
    softwareRequirements: 'Требования к ПО',
    tariffs: 'Наши услуги и тарифы',
    contacts: 'Контакты',
    support: 'Техническая поддержка',
    terms: 'Условия предоставления услуг',
    safeMnj: 'Безопасный My new job ®',
  },
  inputs: {
    email: 'Ваша электронная почта',
    name: 'Имя',
    surname: 'Фамилия',
    patronymic: 'Отчество',
    companyName: 'Название компании',
    email2: 'Электронная почта',
    phoneNumber: 'Номер телефона',
    phone: 'Телефон',
    companyName2: 'Компания',
    person: 'Контактное лицо',
    companyType: 'Тип компании',
    website: 'Сайт компании',
    employeesCount: 'Выберите количество сотрудников',
    city: 'Город',
    next: 'Далее',
  },
  placeholders: {
    role: 'Выберите роль',
    comment: 'Введите комментарий',
    name: 'Введите Ваше имя',
    surname: 'Введите Вашу фамилию',
    companyName: 'Введите название Вашей компании',
    email: 'Введите Вашу электронную почту',
    phoneNumber: 'Введите Ваш номер  телефона',
    enterName: 'Введите имя',
    enterMiddleName: 'Введите отчество',
    placeholderStartDate: 'Начальная дата',
    placeholderEndDate: 'Конечная дата',
    enterText: 'Начните вводить текст',
    fullName: 'Введите ФИО',
  },
  buttons: {
    logIn: 'Войти',
    register: 'Зарегистрироваться',
    watchVideo: 'Смотреть видео',
    startVideocall: 'Начать видеосессию',
    startTrial: 'Попробовать бесплатно',
    details: 'Подробнее',
    saving: 'Сохранение',
    tryFree: 'Попробовать бесплатно',
    save: 'Сохранить',
    toMainPage: 'На главную',
    clear: 'Понятно',
    ok: 'Понятно',
    confirm: 'Подтвердить',
    watchExample: 'Смотреть пример',
    howItWork: 'Как это работает?',
    finish: 'Закончить',
    cancel: 'Отмена',
    sent: 'Отправить',
    close: 'Закрыть',
    subscribe: 'Подписаться',
    submit: 'Отправить',
    dispatch: 'Отправка',
    saveAndSent: 'Сохранить и отправить',
    logOut: 'Выйти',
  },
  validation: {
    isRequired: 'Обязательное к заполнению поле',
    notValidEmail: 'Неправильный формат email',
    maxNumberSize: 'Максимальная длина номера %t% символов',
    minNumberSize: 'Минимальная длина номера %t% символов',
    maxEmailSize: 'Максимальная длина email %t% символов',
    maxNameSize: 'Максимальная длина имя %t% символов',
    maxLastNameSize: 'Максимальная длина фамилии %t% символов',
    maxMiddleNameSize: 'Максимальная длина отчества %t% символов',
  },
  delimeter: {
    or: 'или',
  },
  footer: {
    company: 'ООО «Майньюджоб»',
    downloadPresentation: 'Скачать презентацию',
    contacts: 'Контакты',
    techSupport: 'Техническая поддержка',
    conditions: 'Условия предоставления услуг',
    safeMnj: 'Безопасный My new job',
    requirements: 'Требования к ПО',
    documents: 'Правовые документы',
    policy: 'Политика обработки данных',
    presentRu: 'Скачать презентацию (ру)',
    presentEn: 'Скачать презентацию (ENG)',
    watchPresentation: 'Смотреть видео',
    skolkovo: 'Участник',
  },
  onlinePoll: {
    notifyTitle: 'Хотите получить бесплатный расширенный доступ к услугам платформы My new job®?',
    notifyText: 'Пройдите онлайн-опрос, который займет у Вас не более 10 минут. Помогите нам стать полезнее!',
    notifyBtn: 'Пройти онлайн-опрос',
    startTitle: 'Мы рады приветствовать Вас на странице онлайн-опроса платформы My new job®',
    about: {
      title1: 'Платформа My new job®',
      text1: 'Это инновационная онлайн-платформа для контактного подбора персонала и поиска работы',
      title2: 'Помогите нам стать полезнее для Вас',
      text2: 'Направьте нас на развитие только тех функциональных возможностей платформы, которые будут действительно полезны для Вас',
      title3: 'Пройдите онлайн-опрос',
      text3: 'Для ответа на 10 вопросов Вам потребуется не более 10 минут',
      title4: 'Получите от нас подарок',
      text4: 'Получите промо-код для активации бесплатного расширенного доступа ко всем базовым услугам платформы My new job® сразу же после прохождения онлайн-опроса',
      title5: 'Воспользуйтесь подарком',
      text5: 'Зарегистрируйтесь на платформе My new job®, чтобы воспользоваться бесплатным расширенным доступом </br> После активации доступа Вы получите в выбранном тарифе <mark> от 30 до 120 бесплатных часов записи</mark> видеоматериалов в течение <mark>7 календарных дней</mark>',
      text6: 'Введите Вашу электронную почту - на нее будет отправлен промо-код после полного прохождения онлайн-опроса',
    },
    startOnlinePoll: 'Начать онлайн-опрос',
    inputRole: 'Выберите роль пользователя',
    rateTitle: 'Оцените вопрос по 10 балльной шкале',
    nextQuestion: 'Следующий вопрос',
    rateDescription: {
      title: 'Значение баллов шкалы',
      negative: 'Условно отрицательная оценка',
      neutral: 'Условно нейтральная оценка',
      positive: 'Условно положительная оценка',
    },
    finishTitle: 'Благодарим,</br>Вы помогли нам стать полезнее!',
    promoByMail: 'Промокод успешно отправлен Вам на почту',
    promoByMailE: 'The promocode was successfully sent to you mail.',
    finishText1: 'С этой минуты Вы стали обладателем промо-кода для бесплатного расширенного доступа к функционалу платформы My new job® по тарифу Базовый с возможностью записи видеоматериалов до <mark>30 бесплатных часов</mark> в течение <mark>7 дней</mark>',
    finishText2: 'Зарегистрируйтесь на платформе, чтобы использовать промо-код',
    promoCodeLabel: 'Ваш промо-код',
    terminate: 'Активировать не позднее',
    finishButton: 'Закончить онлайн-опрос',
    notAvailableTitle: 'Онлайн-опрос не доступен',
    notAvailableText: 'Онлайн-опрос доступен только для неавторизованных пользователей.<br />Для прохождения, пожалуйста, выйдите из личного профиля.',
    notEndedTitle: 'Онлайн-опрос пройден не полностью',
    notEndedText: 'Вы ответили не на все вопросы онлайн-опроса. Все равно закончить прохождение онлайн-опроса?',
  },
  units: {
    rublesPerMonth: 'рублей в месяц',
    rublesMonth: 'рублей/месяц',
    rubles: 'рублей',
    month: 'месяц',
    months: 'месяцев',
    threeMonths: 'три месяца',
    halfYear: 'полгода',
    year: 'год',
    hours: 'часов',
    days: 'дней',
    sec: 'сек',
    min: 'минут',
    seconds: 'секунд',
    minS: 'мин',
  },
  tariffs: {
    promoTariff: 'Промо-тариф',
    freeDemoAccess: 'Бесплатный демо-доступ',
    accessTariff: 'Тариф на доступ',
    accessRates: 'Тарифы на доступ',
    serviceTariff: 'Тариф на услугу',
    servicesRates: 'Тарифы на услуги',
    totalDiscount: 'Итого экономия',
    discount: 'Скидка',
    moreThan: 'более',
    choosePeriod: 'Выберите период:',
    totalHours: 'Общее количество часов записи, включенных в тариф.',
    tariffCost: 'Стоимость тарифа:',
    accessPeriod: 'Период действия демо-доступа',
    details: 'Подробнее о тарифе',
    aboutRates: 'Подробнее о тарифе',
    popular: 'Популярно',
    individual: 'Индивидуальный рассчет',
    contactUs: 'Связаться с нами',
    addToCart: 'Тариф успешно добавлен в корзину',
  },
  modalIndividualTariff: {
    title: 'Тариф индивидуальный',
    text: 'Тариф Индивидуальный - это специальная возможность платформы, позволяющая по запросу расширить свойства Стандартных тарифов. После получения запроса администрация платформы обработает запрос и предоставит коммерческое предложение и счёт на оплату. После оплаты будет предоставлен промо-код для активации Индивидуального тарифа.',
    tariffLabel: 'Выберите стандартный тариф, свойства которого необходимо изменить',
    optionsLabel: 'Свойства стандартного тарифа по умолчанию',
    periodLabel: 'Период действия Индивидуального тарифа',
    countLabel: 'Количество активаций / разных пользователей',
    nameLabel: 'ФИО',
    namePlaceholder: 'Введите ФИО',
    phoneLabel: 'Номер телефона',
    emailLabel: 'Электронная почта',
    emailPlaceholder: 'Введите электронную почту',
    descriptionLabel: 'Опишите свои пожелания к тарифу Индивидуальный',
    requisites: 'Прикрепите реквизиты',
    recordingHours: 'часы записи',
    or: 'или',
    mB: 'MB записи',
    days: 'календарных дней',
    selectTariff: 'Выберите тариф',
  },
  nav: {
    main: 'Главная',
    feed: 'Общая лента',
    logIn: 'Войти',
    reg: 'Зарегистрироваться ',
    startVideosession: 'Начать видеосессию',
    findVacancy: 'Найти вакансию',
    findCv: 'Найти резюме',
    myVideosessions: 'Мои видеосессии',
    recordVideoVacancy: 'Запись видеовакансии',
    recordVideoCv: 'Запись видеорезюме',
    myVideovacancies: 'Мои видеовакансии',
    videoBusinessCardRecording: 'Запись видеовизитки',
    myVideoBusinessCard: 'Мои видеовизитки',
    myVideoSurveys: 'Мои видеоопросы',
    contacts: 'Контакты',
    feedback: 'Обратная связь',
    notifications: 'Уведомления',
    vacancies: 'Вакансии',
    closeVacancy: 'Закрыть вакансию',
    favoriteCv: 'Избранные резюме',
    myVideoCv: 'Мои видеорезюме',
    responsesAndInvitations: 'Отклики и приглашения',
    chats: 'Чаты',
    help: 'Помощь',
    mail: 'Почта',
    calendar: 'Календарь',
    requestForRecording: 'Заявки на запись',
    logOut: 'Выход',
    resume: 'Резюме',
    favoriteVacancies: 'Избранные вакансии',
    myPortfolio: 'Моё портфолио',
    controlPanel: 'Панель контроля',
    adminPanel: 'Административная панель',
    statistic: 'Статистика',
    dbHistory: 'База данных - история',
    jobManagement: 'Управление заданиями',
    howItWork: 'Как это работает?',
    aboutCompany: 'О компании',
    services: 'Наши услуги и тарифы',
    forJobSeekers: 'Для соискателей',
    forEmployers: 'Для работодателей',
    forAgency: 'Для кадровых агентств',
    news: 'Новости',
    myAccount: 'Личный кабинет',
    cart: 'Перейти в корзину',
    flow: 'Заявки на поток',
    selection: 'Заявки на подбор',

    freeOnlineVideosession: 'Бесплатные онлайн-видеосессии',
    videoInterviewRecord: 'Запись видеособеседований',
    videoVacancyRecord: 'Запись видеовакансий',
    videoResumeRecord: 'Запись видеорезюме',
    linkPlacement: 'Размещение ссылок',
    videoPollRecord: 'Запись видеоопросов',
    portfolio: 'Портфолио соискателей',
    resumeAndMails: 'Ваши резюме и сопроводительные письма',
    vacanciesBd: 'База данных вакансий',
    searchWork: 'Отклики на вакансии и поиск работы',
    vacanciesAndVideoBusinessCard: 'Ваши вакансии и видеовизитки',
    resumeBd: 'База данных резюме',
    inviteVideoInterview: 'Приглашения на собеседования и поиск сотрудников',
    candidatesFlow: 'Поток кандидатов',
    privatePage: 'Ваша личная страница на платформе',
    downloadPresentationRu: 'Скачать презентацию (ру)',
    downloadPresentationEn: 'Скачать презентацию (анг)',
    tariffs: 'Тарифы и услуги',
    technicalSupport: 'Техническая поддержка',
    servicesTerms: 'Условия предоставления услуг',
    safeMnj: 'Безопасный My new job ®',
    softwareRequirements: 'Требования к ПО',
    documents: 'Правовые документы',
    dataTerms: 'Политика обработки данных',
    emptyCart: 'В вашей корзине пусто',
    servicesCart: 'В вашей корзине услуг',
    cabinet: 'Личный кабинет',
    skolkovo: 'Участник',
    rights: 'Все права защищены',
    mnj: 'Компания My new job®',
  },
  registration: {
    remember: 'Запомнить',
    dontHaveAccount: 'Нет аккаунта?',
    restorePassword: 'Восстановить пароль',
    enter: 'Войти',
    signIn: 'Зарегистрироваться',
    enterPassword: 'Введите пароль',
    enterEmail: 'Введите электронную почту',
    snLogin: 'Вход через социальные сети',
    reg: 'Зарегистрироваться',
    forJobSeekers: 'Для кандидатов',
    forEmployers: 'Для работодателей',
    forAgency: 'Для кадровых агентств',
    jsText: 'Для успешного поиска работы нажмите "Зарегистрироваться", заполните соответствующие поля формы или воспользуйтесь быстрой регистрацией через социальные сети',
    empText: 'Для успешного поиска достойных кандидатов нажмите "Зарегистрироваться", заполните соответствующие поля формы в два этапа',
    agencyText: 'Для успешного поиска достойных кандидатов нажмите "Зарегистрироваться", заполните соответствующие поля формы в два этапа',
    sReg: 'Служебная регистрация',
    completeReg: 'Завершить регистрацию',
    processing1: 'Я даю',
    processing2: 'согласие на обработку персональных данных',
    quickReg: 'Быстрая регистрация через социальные сети',
  },
  feed: {
    filter: 'Фильтр',
    allPosts: 'Все новости',
    myLikes: 'Вам понравилось',
    myComments: 'Ваши комментарии',
    hotV: 'Горячие вакансии',
    pl: 'Платформа для контактного подбора персонала',
    copy: 'Копировать ссылку на публикацию',
    showMore: 'Показать больше',
    hide: 'Скрыть …',
    liked: 'Понравилось',
    comments: 'Комментариев',
    comment: 'Комментировать',
    like: 'Мне нравится',
    hideComments: 'Скрыть комментарии',
    answer: 'Ответить',
    remove: 'Удалить',
    writeComment: 'Написать комментарий',
    firstLike: 'Будь первым, кому понравилось это',
    firstComment: 'Будь первым, кто прокомментирует это',
    showAnswers: 'Показать ответы',
    hideAnswers: 'Скрыть ответы',
    noPosts: 'Нет публикаций',
    noVacancies: 'Нет вакансий',
  },
  time: {
    now: 'только что',
    lessHour: 'менее часа назад',
    hourAgo: 'час назад',
    hoursAgo: 'часов назад',
    hoursAgo2: 'часа назад',
    today: 'Сегодня',
  },
  contacts: {
    userList: 'Справочник My new job',
    recently: 'Недавние',
    contacts: 'Контакты',
    add: 'Добавить в контакты',
    invite: 'Пригласить',
    social: 'Мы в социальных сетях',
  },
  common: {
    characters: 'символов',
    question: 'вопроса',
    question1: 'вопрос',
    questions: 'вопросов',
    loading: 'Загрузка...',
    inviteSuccess: 'Приглашение отправлено',
    sentToParticipants: 'Отправлено участникам',
    sendToParticipants: 'Отправить участникам',
    to: 'до',
    sentByEmail: 'Отправить по эектронной почте',
    openContacts: 'Открыть контакты',
    selectTariff: 'Выбрать тариф',
    save: 'Сохранить',
    saveAs: 'Сохранить как',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    up: 'Поднять',
    down: 'Опустить',
    remove: 'Удалить',
    notFound: 'Ничего не найдено',
    send: 'Отправить',
    sendAs: 'Отправить как',
    sending: 'Отправка',
    add: 'Добавить',
    listIsEmpty: 'Список пуст',
    edit: 'Редактировать',
    saveAndHide: 'Сохранить и свернуть',
    close: 'Закрыть',
    exitText: 'Вы действительно хотите выйти?',
    copyLink: 'Ссылка скопирована',
    saveSuccess: 'Успешно сохранено',
    changeSuccess: 'Успешно изменено',
    sendSuccess: 'Успешно отправлено',
    reject: 'Отклонить',
    accept: 'Принять',
  },
  vpValidation: {
    minQuestion: 'Необходимо добавить минимум %t% вопрос',
  },
  videoPoll: {
    newAnswer: 'Новый ответ на видеоопрос',
    toMyVideoPolls: 'В Мои видеоопросы',
    createVideoPoll: 'Создать видеоопрос',
    generalInfo: 'Общая информация',
    vacancy: 'Вакансия',
    companyName: 'Название компании',
    videoPollStartDelay: 'Начальная задержка видеоопроса',
    questionsCount: 'Количество вопросов',
    totalDuration: 'Общая продолжительность, мин:сек',
    videoPollDatetime: 'Дата и время действия видеоопроса',
    favoritesText: 'Добавляйте в Избранное самые интересные записи ответов на видеоопрос от соискателей. Вы всегда к ним сможете вернуться и пригласить на собеседование. Add to Favorites the most interesting recordings of the answers to the video survey from the applicants. You can always return to them and invite them for an interview.',
    addToTemplates: 'Добавить в шаблоны видеоопросов',
    welcomeMessage: 'Приветствие',
    welcomeMessageDescr: 'Приветственное сообщение, выводится для соискателей',
    questions: 'Вопросы',
    videoPollDescrTitle: 'Описание видеоопроса',
    hideVideoPollDescrTitle: 'Скрыть описание',
    videoPollDescr: 'Опишите подробно цели видеоопроса, его срочность, а также укажите период, в течении которого Вы ждите ответы',
    videoPollDescr1: 'Подробное описание целей видеоопросов, его срочность, а также период в течение которого Вы ждете ответы',
    videoPollPlaceholder: 'Введите описание видеоопроса',
    videoPollMessage1: 'Уважаемый Соискатель!',
    videoPollMessage2: 'Видеоопрос состоит из',
    videoPollTotalDuration: 'Общая продолжительность составит',
    questionsPopup: 'Вы можете добавить до 20-ти вопросов, на которые потенциальные Соискатели должны ответить в течении заданного Вами времени.',
    questionsPopupAddToTemplate: 'Вы можете внести вопрос в список шаблонных вопросов',
    questionsPopupAddFromTemplate: 'Вы можете добавить вопрос из списка шаблонных вопросов',
    enterQuestionText: 'Введите текст вопроса',
    addNewQuestion: 'добавить новый вопрос',
    addQuestionDuration: 'Задайте время <br> на ответ, мин:сек',
    addToQuestionTemplate: 'добавить вопрос в шаблонные вопросы',
    addFromQuestionTemplate: 'добавить вопрос из шаблонных вопросов',
    addTemplateVideoPoll: 'Добавить шаблон видеоопроса',
    addTemplateVideoPollText: 'Вы можете добавить готовый шаблон видеоопроса, например, под конкретную должность или профессию с ранее созданными вопросами',
    howItWork: 'Как это работает?',
    watchExample: 'Смотреть пример',
    save: 'Сохранить',
    edit: 'Редактировать',
    greetDescr: 'Указанное <strong>Приветствие</strong> отображается у потенциального Соискателя на стартовой странице до начала  прохождения видеоопроса',
    delayBetweenQuestions: 'Задержка между вопросами, сек',
    videoPollDescription: 'Здравствуйте, потенциальные Соискатели!\n В нашей компании открыта вакансия на должность\n Вакансия срочная и мы планируем её закрыть не позднее\n Просьба максимально оперативно пройти видеоопрос и направить запись в наш адрес.\n С уважением, \n',
    companyInvite: 'Приглашение отправлено от компании %t%',
    inviteText: 'Вас приглашают пройти видеоопрос на вакансию',
    createVideoPollSuccess: 'Видеоопрос успешно создан',
    myVideoPoll: 'Мой видеоопрос',
    videoPollList: 'Список видеоопросов',
    createNewVp: 'Создать новый видеоопрос',
    hideFilter: 'Скрыть фильтр',
    openFilter: 'Настроить фильтр',
    backToMyVideoPolls: 'В Мои видеоопросы',
    confirmRemoveVideoPoll: 'Вы действительно хотите удалить видеоопрос?',
    noVp: 'Нет видеоопросов',
    vpInviteTitle: 'Пригласите зарегистрированного соискателя на видеоопрос',
    forNotRegUsers: 'Для незарегистрированных и неавторизованных пользователей',
    forRegUsers: 'Для зарегистрированных пользователей',
    vpLink: 'Ссылка на видеоопрос',
    created: 'создан',
    editedLastTime: 'отредактирован в последний раз',
    receivedLastTime: 'получен в последний раз',
    receivedTime: 'получен',
    sentLastTime: 'отправлен в последний раз',
    receivedFrom: 'Получен от:',
    recordingLastTime: 'записан в последний раз',
    sentedVp: 'Отправленные видеоопросы',
    sendVp: 'Отправить видеоопрос',
    notAllowedTariff: 'Ваш текущий активный тариф не позволяет отправлять на прохождение созданные видеоопросы.',
    notAllowedTariffDescr: 'Для получения доступа на отправку созданных видеоопросов приобретите соответствующий тариф.',
    removeVp: 'Удалить видеоопрос',
    receivedVp: 'Полученные от соискателей ответы',
    hideList: 'Свернуть список',
    showList: 'Показать список',
    addToQuestionTemplateList: 'Вопрос добавлен в шаблонные вопросы',
    shareByEmail: 'Отправить ссылку на видео опрос по электронной почте',
    shareByEmailSuccess: 'Ссылка успешно отправлена',
    sharedLink: 'Ссылка на прохождение видеоопроса',
    addQuestionFromTemplates: 'Добавьте видеоопрос из списка шаблонных видеоопросов',
    questionListIsEmpty: 'Список шаблонных видеоопросов пуст',
    createVp: 'Создать видеоопрос',
    vpList: 'Список видеоопросов и отправка на прохождение',
    sendAndReceived: 'Отправленные и полученные видеоопросы',
    favoriteVP: 'Избранные видеоопросы',
    vpTemplates: 'Шаблоны вопросов и видеоопросов',
    myVP: 'Мои видеоопросы',
    received: 'Получено',
    noReceivedVp: 'Нет полученных видеоопросов',
    noSendVp: 'Нет отправленных видеоопросов',
    send: 'Отправлено',
    rating: 'Рейтинг',
    anyRating: 'Любой рейтинг',
    sendInvition: 'Отправленные приглашения зарегистрированным соискателям',
    answerTime: 'Дата и время ответа',
    roleApplicant: 'Соискатель',
    completedVideoSurveyLink: 'Ссылка на пройденные видеоопросы',
    noFavoriteVp: 'Нет избранных видеоопросов',
    videoSurveyTemplates: 'Шаблоны видеоопросов',
    tmplVsName: 'Введите название шаблона видеоопроса',
    addNewTemplate: 'Добавить новый шаблон',
    templateVsList: 'Список шаблонов видеоопросов',
    vsTmplEdit: 'Редактирование шаблона видеоопроса',
    vsTmplEditText: 'Отредактируйте название шаблона видеоопроса',
    vsTmplNamePlaceholder: 'Введите название шаблона видеоопроса',
    vsTmplText: 'Введите вопрос в шаблон видеоопроса или добавьте из списка шаблонных вопросов',
    vsTmplQuestionPlaceholder: 'Введите вопрос',
    questionTmpl: 'Шаблоны вопросов',
    enterQuestionPlaceholder: 'Введите вопрос',
    listOfQuestionTemplates: 'Список шаблонных вопросов',
    addToVpTemplate: 'Добавить в шаблон видеоопроса',
    removeVsRecord: 'Вы действительно хотите удалить запись видеоопроса?',
    sendError: 'Не удалось отправить видеоопрос',
    sendEndDate: 'Запись своих ответов Вы можете отправить не позднее </br> %t%',
    vpDescr: 'Описание видеоопроса',
    recordedVp: 'Записанные видеоопросы',
    recordVpDescr: 'Вы можете пройти видеоопрос и <br /> отправить запись',
    startVp: 'Пройти видеоопрос',
    videoPollLink: 'Ссылка на пройденный видеоопрос',
    vpIsLoading: 'видеоопрос обрабатывается',
    recorded: 'записан',
    sended: 'отправлен',
    notValidAccount: 'Для прохождения видеоопроса авторизуйтесь как кандидат или',
    reg: 'зарегистрируйте',
    candidateAccount: 'аккаунт кандидата',
    addFromTemplateList: 'Добавьте вопрос из списка шаблонных вопросов',
    tmplListIsEmpty: 'Список шаблонных вопросов пуст',
  },
  vpHelperCandidate: {
    one: 'Прочтите описание видеоопросов. <br/> Выберите компанию и вакансию, которая <br/> Вам наиболее интересна',
    two: 'Пройдите видеоопрос в режиме онлайн в <br> свободное время',
    three: 'Запишите неограниченное количество <br/> ответов на видеоопрос',
    four: 'Отправьте наиболее удачную запись ответов <br/> на видеоопрос автору видеоопроса и <br/> ждите приглашение на очное собеседование.',
    five: 'Поделитесь записью ответов на видеоопрос, <br/> в том числе и с незарегистрированными',
  },
  vpHelperEmployer: {
    one: 'До начала организации видеоопроса создайте шаблонные вопросы или целые шаблоны видеоопросов, которые наиболее характерны Вашей вакансии или должности',
    two: 'Создайте видеоопрос для конкретной вакансии, введите наиболее раскрывающие соискателя вопросы и задайте время на ответ, а также период действия видеоопроса. Используйте ранее созданные шаблонные вопросы или целые шаблоны видеоопросов.',
    three: 'Отправьте созданные видеоопросы зарегистрированным и незарегистрированным пользователям, направляйте приглашение или уникальную ссылку по электронной почте.',
    four: 'Проверяйте список соискателей, которым Вы отправили приглашение или уникальную ссылку. Просматривайте записи ответов на Ваш видеоопрос, выбирайте лучших соискателей.',
    five: 'Добавляйте в Избранное самые интересные записи ответов на видеоопрос от соискателей. Вы всегда к ним сможете вернуться и пригласить на собеседование.',
  },
  vpRecord: {
    removeText: 'Вы действительно хотите прервать прохождение видеоопроса? <br/> Вся текущая запись ответов будет утеряна.',
    stopText: 'Прервать прохождение видеоопроса?',
    submitStopTex: 'Да, я хочу прервать запись',
    vacancy: 'Видеоопрос на вакансию',
    company: 'В компанию',
    nextQuestion: 'Следующий вопрос начнется через:',
    startText: 'Запись ответов на видеоопрос начнется через',
    delayTextDescr: 'время задержки до начала записи установил инициатор видеоопроса',
    startRecording: 'Начать запись видеоопроса',
    startRecordingAgain: 'Начать заново запись видеоопроса',
    startRecordingRemovePrev: 'Удалить предыдущую запись',
    sendSuccess: 'Видеоопрос успешно отправлен',
    user: 'Пользователю',
    sendTitle: 'Отправка видеоопроса',
    recordSuccess: 'Вы успешно записали видеоопрос.',
    endOfHours: 'Окончание количества часов записи',
    endOfHoursText: 'К сожалению, у автора видеоопроса закочнились часы записи.',
    recordFormText: 'Заполните поля для возможности отправки видеоопроса работодателю (все поля обязательны для заполнения).',
    recordIsLoading: 'Видеозапись обрабатывается',
    saveText: 'Не дожидаясь полного сохранения, Вы можете назначить задачу системе - отправка обработанной записи видеоопроса инициатору',
    saveNotFull: 'Поскольку запись на весь видеоопрос сохранена не полностью, Вы можете её не отправлять инициатору видеоопроса',
    saveAndLoading: 'Обработка, сохранение и отправка видеоопроса',
    saveAndLoadingText: 'Видеозапись обрабатывается. После обработки она будет автоматически сохранена на Вашей странице',
    recordSuccessRemoved: 'Запись успешно удалена',

    addToFavorite: 'Добавить в избранное',
    removeFromFavorite: 'Удалить из избранного',
    goToNextQuestion: 'Перейти к следующему вопросу',
    minScreen: 'Перейти в уменьшенный режим изображения',
    stop: 'Остановить воспроизведение видеоопроса',
    startPause: 'Начать / продолжить воспроизведение записи видеоопроса',
    rate: 'Оцените ответ кандидата',
  },
  filter: {
    hideFilter: 'Скрыть фильтр',
    openFilter: 'Настроить фильтр',
    period: 'За период',
    date: 'По дате',
    companyName: 'По названию компании',
    vacancyName: 'По наименованию вакансии',
    vacancyNamePlaceholder: 'Введите наименование вакансии',
    companyNamePlaceholder: 'Введите название компании',
    apply: 'Применить фильтр',
    reset: 'Сбросить фильтр',
    datePlaceholder: 'Выберите дату',
    fromPeriod: 'За период с',
    toPeriod: 'по',
    byName: 'поиск по ФИО',
  },
  helper: {
    showHide: 'показать/скрыть помощник',
    show: 'Показать помощник при переходе на страницу',
    hide: 'Скрыть помощник при переходе на страницу',
  },
  vs: {
    pageList: 'Ниже представлен список всех записанных и сохранённых видеосессий',
    descrAuth: 'Для того, чтобы начать общение просто нажмите на любой экран ниже.<br>Разрешите Вашему браузеру использовать камеру и микрофон. <br> Пригласите незарегистрированных пользователей на видеосессию, просто отправьте уникальную ссылку. <br /> Пригласите зарегистрированных пользователей на видеосессию, просто отправьте приглашение.',
    descrNotAuth: 'Для того, чтобы начать общение просто нажмите на любой экран ниже.<br>Разрешите Вашему браузеру использовать камеру и микрофон. <br> Пригласите до двух пользователей на видеосессию, просто отправьте уникальную ссылку.',
    chat: 'Общий чат',
    chatTyping: 'печатает',
    form: 'Поле для заметок',
    formClear: 'Очистить поле',
    chatPlaceholder: 'Введите Ваше сообщение',
    pressVs: 'нажмите, чтобы',
    startVs: 'начать видеосессию',
    inviteVs: 'отправить приглашение',
    cancelInviteVs: 'Отменить приглашение',
    sendInvite: 'Приглашение отправлено',
    recording: 'Запись идет',
    vs: 'Начать видеосессию',
    loadingText: 'Подождите, идет подключение <br /> пользователя к видеосессии',
    maxEmailCount: 'Не более %t%-х адресов',
    sendLink: 'Ссылка на вход в кабинет для видеосессии',
    sendByEmail: 'Отправить ссылку на видеосессию по электронной почте',
    vsRecordAccess: 'Для получения доступа к записи видеосессии необходимо выбрать и приобрести соответствующий тариф',
    vsRecordAuth: 'Запись видеосессии доступна только для авторизованных пользователей',
    myInstruction: 'Своя версия инструкции',
    adminInstruction: 'Типовая инструкция по записи',
    videoResume: 'видеорезюме',
    videoVacancy: 'видеовакансии',
    recordModalTitle: 'Предупреждение о записи видеосессии',
    recordModalText: 'Запускается запись текущей видеосессии',
    recordModalUser: 'Запускает пользователь',
    vsEnd: 'Видеосессия завершена',
    creatorLeave: 'Создатель видеосессии покинул комнату',
    inviteToVs: 'Пригласить на видеосессию',
    savingVs: 'Обработка и сохранение видеозаписи',
    endTariffHours: 'Окончание количества часов записи в тарифе',
    vsSuccess: 'Вы успешно провели видеосессию.',
    endHours: 'К сожалению, количество часов записи в Вашем тарифе полностью закончилось.',
    vsVideoSaving: 'Видеозапись обрабатывается. После обработки она будет автоматически сохранена на Вашей странице',
    vsBuyTariff: 'Для того, чтобы иметь возможность и дальше записывать видеосессии, приобретите соответствующий тариф.',
    vsRecordStart: 'Запуск записи текущей видеосессии',
    vsRecordStartT: 'Вы запускаете запись текущей видеосессии',
    vsRecordStartT2: 'После окончания видеосессии запись можно',
    vsReject: 'Отклонение записи видеосессии',
    vsRecordReject: 'Запись видеосессии была отклонена пользователями',
    vsWaiting: 'Ожидание подтверждения записи',
    startRecVs: 'Запуск записи текущей видеосессии',
    startRecVsText: 'Вы запускаете запись текущей видеосессии',
    startRecVsText1: 'После окончания видеосессии запись можно',
    saveTo: 'сохранить в',
    notSaveTo: 'не сохранить в',
    sendToUsers: 'отправить запись участникам видеосессии',
    noVideoRecords: 'Нет видеозаписей',
    removeText: 'Вы действительно хотите удалить видеозапись ?',
    sendText: 'Высылаю Вам видеозапись',
    vsLink: 'Ссылка на видеосессию',
  },
  vsHelper: {
    one: 'Для того, чтобы начать общение </br> просто нажмите на любой экран',
    two: 'Разрешите Вашему браузеру </br> использовать камеру и микрофон',
    three: 'Пригласите зарегистрированных </br>пользователей на видеосессию, </br> просто отправьте приглашение',
    four: 'Пригласите незарегистрированных </br>пользователей на видеосесссию, </br> просто отправьте уникальную ссылку',
    five: 'Запишите видеосессию с пользователями. </br> Готовая запись видеосессии автоматически </br> сохранится в <strong>Мои видеосессии</strong>',
  },
  vsBusinessHelper: {
    one: 'Для того, чтобы начать запись Вашей </br> видеовизитки нажмите на любой экран',
    two: 'Разрешите Вашему браузеру </br> использовать камеру и микрофон',
    three: 'Начните онлайн-видеосесссию. </br> Подготовьтесь, в поле для заметок </br> скопируйте конспект текста Вашей </br> видеовизитки',
    four: 'Начните запись Вашей видеовизитки. </br> Будьте яркими, открытыми и интересными </br> для потенциальных соискателей',
    five: 'Готовая запись Вашей видеовизитки </br> автоматически сохранится в <strong>Мои видеовизитки</strong>',
  },
  vsVacancyHelper: {
    one: 'Для записи самостоятельной </br> видеовакансии воспользуйтесь типовой </br> инструкцией по записи видеовакансии',
    two: 'Создайте свою версию инструкции по </br> записи видеовакансии',
    three: 'Посмотрите видеопримеры записи </br> видеовакансий и видеорезюме, а также </br> видеопомощник - «Как это работает?»',
    four: 'Разверните поле с инструкцией во весь </br> экран, это позволит Вам иметь её перед </br> глазами при записи видеовакансии',
    five: 'Воспользуйтесь полем для заметок во время </br> записи видеовакансии </br> Копируйте нужный текст шаблона прям в поле </br> для заметок, это поможет Вам записать более </br> эффективную видеовакансию',
  },
  videoSessionTitle: {
    resume: 'Запись видеорезюме',
    vacancy: 'Запись видеовакансии',
    session: 'Начать видеосессию',
    businessCard: 'Запись видеовизитки',
  },
  videoRecordsTitle: {
    resume: 'Мои видеорезюме',
    vacancy: 'Мои видеовакансии',
    session: 'Мои видеосессии',
    businessCard: 'Мои видеовизитки',
  },
  vsToolbar: {
    chat: 'Чаты и личные сообщения',
    endCall: 'Завершить звонок',
    cameraOn: 'Включить камеру',
    cameraOff: 'Выключить камеру',
    full: 'Развернуть видеосессию на весь экран',
    minimize: 'Уменьшить экран',
    microOn: 'Включить микрофон',
    microOff: 'Выключить микрофон',
    pause: 'Поставить на паузу',
    record: 'Запись',
    stop: 'Остановить',
    changeCamera: 'Сменить камеру',
    videoresumeInstruction: 'Инструкция видеорезюме',
    videovacancyInstruction: 'Инструкция видеовакансия',
  },
};
